import React from "react";
import { Input, InputGroup, InputRightAddon } from "@chakra-ui/react";

function InputBox(props) {
  return (
    <InputGroup>
      <Input
        placeholder={props.title}
        onChange={props.handler}
        onKeyPress={props.handleKey}
      />
      <InputRightAddon children="mg/week" />
    </InputGroup>
  );
}

export default InputBox;
